<template>
  <div>
    <p
      id="sender-message"
      ref="senderMessage"
      :class="{ visible: isFullMessageVisible, overflow: isMessageOverflow }"
      v-html="$sanitize(shareMessage)" />
    <div
      v-if="isMessageOverflow"
      id="show-full-message"
      class="mb-3 w-100 text-right"
      @click="toggleMessageVisible">
      <span
        v-if="isFullMessageVisible"
        key="hide"
        v-translate> Hide full message </span>
      <span
        v-else
        key="show"
        v-translate> Show full message </span>
      <em
        :class="{
          'qx-icon icon-arrow-down': !isFullMessageVisible,
          'qx-icon icon-arrow-up': isFullMessageVisible,
        }"
        class="arrow"
        aria-hidden="true" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareMessage',
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isMessageOverflow: false,
      isFullMessageVisible: false,
    };
  },
  computed: {
    shareMessage() {
      return this.message.replace(/\n/g, '<br/>') || '';
    },
  },
  mounted() {
    if (this.$refs.senderMessage) {
      this.isMessageOverflow = this.$refs.senderMessage.scrollHeight > this.$refs.senderMessage.clientHeight;
    }
  },
  methods: {
    toggleMessageVisible() {
      this.isFullMessageVisible = !this.isFullMessageVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
#sender-message {
  max-height: 75px;
  overflow: hidden;
  &.visible {
    max-height: none;
  }
  &.overflow {
    margin-bottom: 0;
  }
}
#show-full-message {
  color: $base-blue;
  cursor: pointer;
  .arrow {
    font-size: 14px;
  }
}
</style>
